module.exports = __webpack_public_path__ + "img/hc_login_2.dfb23c4d.png";